import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Loader2 } from 'lucide-react';

const LoadingSpinner = ({ size = 'md', fullScreen = false, text = 'Loading...' }) => {
  const { theme } = useTheme();

  const sizes = {
    sm: 20,
    md: 32,
    lg: 48,
  };

  const containerStyles = fullScreen
    ? {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.background,
        zIndex: 9999,
      }
    : {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
      };

  const textStyles = {
    marginTop: '16px',
    fontSize: '14px',
    color: theme.colors.textSecondary,
  };

  return (
    <div style={containerStyles}>
      <Loader2
        size={sizes[size]}
        color={theme.colors.primary}
        style={{
          animation: 'spin 1s linear infinite',
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      {text && <div style={textStyles}>{text}</div>}
    </div>
  );
};

export default LoadingSpinner;
